<template>
  <div class="igaog clearfix">
    <div class="w">
      <b v-if="isDesktop">历史得记忆，文明得载体，社会得财富</b>
      <b v-else >发现天赋,激发兴趣,培养特长</b>
      <p></p>
      <p v-if="isDesktop">我们将提供最优质得档案培训工作</p>
      <p v-else>专业的科技课程设计、 助力成长，成绩斐然！</p>
      <p></p>
      <div class="link">
        <a href="/about" class="gao_link">
          关于我们
          <em></em>
        </a>
        <a href="/contact" class="gao_link">联系我们</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isDesktop: window.innerWidth > 428,
    };
  },
  mounted() {
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {  
    handleResize() {
      // 根据窗口宽度更新 isDesktop 状态
      }
    }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/pc/igaog.scss";
@import "@/assets/css/move/igaog.scss"
</style>